import * as types from '../constants/terminalsConstants';
import * as api from '../../api/api';


export function getTerminalSuccess(terminals) {
	return {
		type: types.GET_TERMINAL_SUCCESS,
		response: terminals,
	};
}

export function getTerminalList(clientId, merchantId) {
	return function (dispatch) {
		return api.get(`terminals/client/${clientId}/merchant/${merchantId}`)
			.then(function (response) {
				dispatch(getTerminalSuccess(response));
			}).catch(function (error) {

			});
	};
}


// WEBPACK FOOTER //
// ./app/terminals/actions/terminalsActions.js